import { render, staticRenderFns } from "./sw-email-input.vue?vue&type=template&id=18f48928&scoped=true&"
import script from "./sw-email-input.vue?vue&type=script&lang=ts&"
export * from "./sw-email-input.vue?vue&type=script&lang=ts&"
import style0 from "./sw-email-input.vue?vue&type=style&index=0&id=18f48928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f48928",
  null
  
)

export default component.exports